<template>
  <ul class="nav">
    <li class="nav-item border-left-0">
      <a class="nav-link" role="button" aria-haspopup="true" aria-expanded="false">
        <img src="~../assets/image/icon/tag.png" height="40" />
      </a>
    </li>
    <li class="nav-item dropdown">
      <a class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
        {{ language }}
      </a>

      <div class="dropdown-menu">
        <a class="dropdown-item" @click="updatePage({ language: '' })">
          ALL
        </a>
        <template v-for="(filter, index) in lessonFilters">
          <hr>
          <a class="dropdown-item" @click="updateLangIndex(index)">
            {{ filter.languageName }}
          </a>
        </template>
      </div>
    </li>

    <li class="nav-item dropdown">
      <a class="nav-link dropdown-toggle" v-bind:class="{ 'disabled-link': !lessonFilters[currentIndex] }" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
        {{ category }}
      </a>

      <div class="dropdown-menu" v-if="lessonFilters[currentIndex]">
        <a class="dropdown-item" @click="updatePage({ categoryId: '' })">
          ALL
        </a>
        <template v-for="(category, index) in lessonFilters[currentIndex].categories">
          <hr>
          <a class="dropdown-item" @click="updatePage({ categoryId: category.Key })">
            {{ category.Value }}
          </a>
        </template>
      </div>
      <div class="dropdown-menu d-none" v-else></div>
    </li>

    <li class="nav-item dropdown">
      <a class="nav-link dropdown-toggle" v-bind:class="{ 'disabled-link': !lessonFilters[currentIndex] }" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" >
        {{ level }}
      </a>

      <div class="dropdown-menu" v-if="lessonFilters[currentIndex]">
        <a class="dropdown-item" @click="updatePage({ level: '' })">
          ALL
        </a>
        <template v-for="(level, index) in lessonFilters[currentIndex].levels">
          <hr>
          <a class="dropdown-item" @click="updatePage({ level: level })">
            {{ level }}
          </a>
        </template>
      </div>
      <div class="dropdown-menu d-none" v-else></div>
    </li>
  </ul>
</template>

<script>
import lessonFilterMixin from './lessonFilterMixin'
export default {

  name: 'LessonFilter',

  mixins: [lessonFilterMixin]
}
</script>

<style lang="scss" scoped>
  .dropdown-toggle::after {
    margin-left: 2em;
  }

  hr {
    border-color: #ccc;
    width: 80%;
    margin-top: 0;
    margin-bottom: 0;
  }

  a {
    cursor: pointer;

    &:active {
      background-color: #ccc;
    }
  }

  a.disabled-link,
  a.disabled-link:visited ,
  a.disabled-link:active,
  a.disabled-link:hover {
    background-color: #d9d9d9 !important;
    color: #aaa !important;
  }
</style>


// WEBPACK FOOTER //
// LessonFilter.vue?65c9d5fb